export const OTP_EMPTY_ERR= "Invalid OTP code entered. Please try again."
export const DOWNLOAD_TITLE = "Download of User Ban List"
export const DOWNLOAD_SUB_TITLE = "Please select 'Proceed' to download User Ban List in .csv format. Downloaded file can be opened using MS Excel."
export const PROCEED="Proceed"
export const OK = 'Ok'
export const LOGIN= "Login"
export const SUBMIT= "Submit"
export const OTP_ERROR = "Invalid OTP code entered. Please try again."
export const CLR_FILE_STATUS_UNAVAILABLE = "UNAVAILABLE"
export const CLR_FILE_STATUS_AVAILABLE = "SUCCESS"
export const NEXT = 'Next'
export const PASSWORD_TO_MATCH = 'Passwords mismatch.'
export const PASSWORD_WITHOUT_UN = "The new password cannot include username."
export const USER_NAME_REQUIRED = "Username is required"
export const NEW_PASS_REQUIRED = "New Password is required"
export const CONF_PASS_REQUIRED = "Confirm Password is required"
export const EMAIL_RECOVERY ="Email Recovery Code"
export const CANCEL ="Cancel"
export const CODE_LENGTH = 6
export const RESET_SUBTITLE ="Dont worry it happens to the best of us"
export const LOGIN_SUBTITLE ="Operations monitoring and enforcement applications for sharing information"
export const MFA_SUBTITLE ="Secure your account with two step authentication"
export const CHNG_PASS_SUBTITLE ="Frequently change password to be secure"
export const MFA_VERF_TITLE="Authenticator Verification"
export const WEBSITE_TITLE ="DSL Monitoring"
export const SUCCESS ="SUCCESS"
export const PASSWORD_SUCCESSFUL_STATUS ="Password updated successfully."
export const PASSWORD_FAILURE_STATUS ="Password update failed."
export const PASSWORD_COMPLEXITY_ERR = "Password should contain 12 characters with at least 1 uppercase alphabet, 1 lowercase alphabet, 1 number, and 1 special character."

export const MFA_VERFICATION_TEXT="Please enter OTP code generated from your Authenticator app."
export const MFA_SETUP_STEP_TITLE="Please complete the following steps to configure a one-time set up."
export const MFA_SETUP_STEP_1="Install Google Authenticator app from your Android or iOS device app store."
export const MFA_SETUP_STEP_2="Open the app and tap on the “+” button / select “Scan a QR Code”."
export const MFA_SETUP_STEP_3="Scan the QR code below."
export const MFA_SETUP_STEP_4="Please enter the OTP code generated from Authenticator."

export const CONFIRM_RESET_OTP_RETRY="Didn’t receive the code? "
export const CONFIRM_RESET_OTP_CLICK="Click after  "
export const RESET_CONFIRM_OTP_TEXT="Please enter OTP code sent to your email."
export const ENQUIRY_TEXT="For enquiries, please contact us at dso_class_licence@lta.gov.sg."
export const MFA_SETUP_SUCCESSFUL_STATUS ="Authenticator setup completed."

export const USER_TYPE='user'
export const OPPR_TPYE='oppr'
export const HOME_SUBTITLE="What would you like to do today?"

export const USER="user"
export const OPERATOR="operator"